import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button, Flex, Heading, Text } from "@chakra-ui/react";
import { usePartner } from "~/OnboardingApp/hooks";
import { Trans } from "~/utils/i18next";
import { EmailLink } from "./EmailLink";

const components = {
  EmailLink: <EmailLink />,
};

interface Props {
  onClose: () => void;
}

export const HelpModalContent: FC<Props> = ({ onClose }) => {
  const { t } = useTranslation();
  const { partnerMeta } = usePartner();
  const partnerName = partnerMeta.name;
  const partnerEmail = partnerMeta.email;

  return (
    <Flex direction="column" gap="1.5rem" px="2rem" py="3rem">
      <Heading variant="th-h6">
        {t("onboarding.activate.modal.heading", { partnerName })}
      </Heading>
      <Text variant="th-body1">
        {t("onboarding.activate.modal.description1", { partnerName })}
      </Text>
      <Text variant="th-body1">
        <Trans
          i18nKey="onboarding.activate.modal.description2"
          components={components}
          values={{ partnerEmail }}
        />
      </Text>
      <Button fontSize="18px" onClick={onClose} variant="th-secondary" w="full">
        {t("onboarding.activate.modal.cta")}
      </Button>
    </Flex>
  );
};
